import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToEOI = () => {
    const element = document.getElementById('eoi-form');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-40 bg-[#050505] relative z-10 overflow-hidden border-t border-white/5" data-id="element-480">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-orange/10 rounded-full blur-[150px] pointer-events-none" data-id="element-481" />

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10" data-id="element-482">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-5xl md:text-7xl font-display mb-12 leading-[1.0] tracking-tight text-balance text-white" data-id="element-483">
          The venues that adopt AI first will define the next decade of
          hospitality.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-484">
          <button onClick={scrollToEOI} className="bg-brand-orange hover:bg-brand-deep-orange text-white px-12 py-6 rounded-full font-medium transition-all duration-300 shadow-[0_0_40px_rgba(219,127,74,0.3)] hover:shadow-[0_0_60px_rgba(219,127,74,0.4)] text-xl" data-id="element-485">
            Register Your Interest
          </button>
        </motion.div>
      </div>
    </section>;
}